import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-member",
  "use": "icon-member-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-member\"><path d=\"M925.44 260.8L717.867 388.693 518.827 123.2c-3.414-4.587-10.24-4.587-13.76 0L306.133 388.693 98.453 260.8c-6.08-3.733-13.973 1.28-13.013 8.427l81.493 619.306c1.174 8.427 8.427 14.934 17.067 14.934h656.107c8.533 0 15.893-6.4 16.96-14.934l81.493-619.306c0.853-7.147-6.933-12.16-13.12-8.427z m-134.4 569.707H232.853l-57.386-436.694 149.12 91.84L512 235.627l187.413 250.026 149.12-91.84-57.493 436.694z\" p-id=\"8303\" fill=\"#ffffff\" /><path d=\"M512 508.8c-66.24 0-120.107 53.867-120.107 120.107S445.76 749.013 512 749.013s120.107-53.866 120.107-120.106S578.24 508.8 512 508.8z m0 171.627c-28.373 0-51.413-23.04-51.413-51.52 0-28.374 23.04-51.52 51.413-51.52s51.413 23.04 51.413 51.52c0 28.373-23.04 51.52-51.413 51.52z\" p-id=\"8304\" fill=\"#ffffff\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/member.svg
// module id = /LrJ
// module chunks = 51